import { useNavigate } from 'react-router-dom';
import * as FxLog from '../fx/FxLog';
import { getStoreValue } from "../gx/GxStore";

export const useNav = () => {
  let navigate = useNavigate();
  
  const isCP = () => { return Boolean(getStoreValue('StoreSession', 'inClientCP')) } // 2023-05-26 - daq: Portal del Cliente

  const _nav = (to, options) => {
    FxLog.infox('useNav._nav', '..._navStack():', _navStack());
    navigate(to, options);
  }

  const _navExit = () => {
    let path = isCP() ? 'cp' : 'login';
    sessionStorage.clear();
    _nav(`/${path}`, { replace: true });
  }

  const _navTo = (url, navParams) => {
    let arUrl = JSON.parse(sessionStorage.getItem('useNav.urlStack'))||[];
    arUrl.push(url);
    sessionStorage.setItem('useNav.urlStack', JSON.stringify(arUrl));
    sessionStorage.setItem('useNav.count', (Number(sessionStorage.getItem('useNav.count')||0) + 1).toString());
    _nav(`/${isCP() ? 'main_cp' : 'main'}/${url}`, { replace: true, state: navParams }); //useLocation() captura los params
  }

  const _navBack = (navParams) => {
    let arUrl = JSON.parse(sessionStorage.getItem('useNav.urlStack'))||[];
    arUrl.pop();
    let url = arUrl.slice(-1)[0];
    sessionStorage.setItem('useNav.urlStack', JSON.stringify(arUrl));
    sessionStorage.setItem('useNav.count', (Number(sessionStorage.getItem('useNav.count')||0) - 1).toString());
    if (url) {
      _nav(`/${isCP() ? 'main_cp' : 'main'}/${url}`, { replace: true, state: navParams /* ej: GxSlsAuxTableItem y GxSlsAuxTableItem */ }); //useLocation() captura los params
    }
  }

  const _navFirst = (navParams) => {
    let arUrl = JSON.parse(sessionStorage.getItem('useNav.urlStack')) || [];
    
    if (arUrl.length > 0) {
      // 1. Buscamos el índice de la primera URL que sea realmente válida (que no sea vacía ni 'blank')
      let firstValidIndex = arUrl.findIndex(url => url && url.trim() !== '' && url !== 'blank');
      
      if (firstValidIndex !== -1) {
        let firstUrl = arUrl[firstValidIndex];
        
        // 2. Cortamos el stack justo hasta esa primera página válida.
        // Esto preserva cualquier estructura subyacente (ej. ['', 'clientes']) que tu app necesite.
        let newStack = arUrl.slice(0, firstValidIndex + 1);
        
        sessionStorage.setItem('useNav.urlStack', JSON.stringify(newStack));
        sessionStorage.setItem('useNav.count', newStack.length.toString());
        
        _nav(`/${isCP() ? 'main_cp' : 'main'}/${firstUrl}`, { replace: true, state: navParams });
      } else {
        // Fallback de seguridad por si todo el array estuviera corrupto
        let firstUrl = arUrl[0];
        sessionStorage.setItem('useNav.urlStack', JSON.stringify([firstUrl]));
        sessionStorage.setItem('useNav.count', '1');
        _nav(`/${isCP() ? 'main_cp' : 'main'}/${firstUrl}`, { replace: true, state: navParams });
      }
    }
  }

  const _navStack = () => {
    return JSON.parse(sessionStorage.getItem('useNav.urlStack'));
  }

  /** devuelve la posición en que se encuentra la url pasada, o false si no la encuentra. */
  const _navStackFind = (url) => {
    const stack = _navStack();
    if (!Array.isArray(stack)) {
      return false; // Manejo de error: _navStack() no devolvió un array
    }
    return stack.includes(url);
  };

  /** quita la url del stack, o false si no la encuentra. */
  const _navStackRemove = (url) => {
    const stack = _navStack();
    if (!Array.isArray(stack)) {
      return false; // Manejo de error: _navStack() no devolvió un array
    }

    const index = stack.indexOf(url);
    if (index === -1) {
      return false; // URL no encontrada
    }

    stack.splice(index, 1); // Elimina la URL
    sessionStorage.setItem('useNav.urlStack', JSON.stringify(stack));
    sessionStorage.setItem('useNav.count', stack.length.toString());
    return true;
  };

  const _navClear = () => {
    sessionStorage.removeItem('useNav.urlStack');
    sessionStorage.setItem('useNav.count', '0');
    //_navTo('blank'); // 2025-03-17 - daq: quitado porque provoca que se pierda el hilo de cuándo poner las flechas de retroceso.
  }

  const _navCount = () => {
    let count = sessionStorage.getItem('useNav.count')||0;
    FxLog.infox('useNav._navCount', 'count: ' + count);
    return count;
  }

  return [
    {
      navTo: _navTo,
      navBack: _navBack,
      navFirst: _navFirst,
      navClear: _navClear,
      navCount: _navCount,
      navExit: _navExit,
      navStack: _navStack,
      navStackFind: _navStackFind,
      navStackRemove: _navStackRemove,
    },
  ];
};
